exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-a9064afe]{width:1.12rem;height:0.28rem;display:flex;align-items:center;color:#1F1F1F;font-size:0.14rem;border-radius:0.04rem;line-height:0.28rem}.status img[data-v-a9064afe]{width:0.24rem;margin-right:0.06rem;margin-left:0.1rem}.status.ing[data-v-a9064afe]{background:rgba(0,199,131,0.2);color:#00C783}.status.passed[data-v-a9064afe]{background:rgba(49,114,253,0.2);color:#3172FD}.status.failed[data-v-a9064afe]{background:rgba(146,157,173,0.2);color:#929DAD}\n", ""]);

// exports
